module.exports = __webpack_public_path__ + "static/media/about.99b202da.jpg";